<template>
  <div class="login-wrapper">
    <div class="login-container">
      <div class="login-card">
        <div class="card-header text-center">
          <h2 class="auth-title">Admin Sign In</h2>
          <p class="auth-subtitle">Please enter your credentials to access the dashboard</p>
        </div>
        <form @submit.prevent="handleLogin" class="login-form">
          <div class="form-group mb-4">
            <label for="email" class="form-label">Email Address</label>
            <div class="input-container">
              <input
                type="email"
                id="email"
                v-model="email"
                placeholder="email@example.com"
                class="form-input"
                required
              />
            </div>
          </div>
          <div class="form-group mb-4">
            <label for="password" class="form-label">Password</label>
            <div class="input-container">
              <input
                type="password"
                id="password"
                v-model="password"
                placeholder="••••••••"
                class="form-input"
                required
              />
            </div>
          </div>

          <div v-if="errorMsg" class="error-banner mb-3">
            {{ errorMsg }}
          </div>

          <button type="submit" :disabled="loading" class="btn-submit">
            <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
            Sign In
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'LoginPage',
  data() {
    return {
      email: '',
      password: '',
      loading: false,
      errorMsg: ''
    }
  },
  mounted() {
    // Hide footer if visible
    const footer = document.querySelector(".thisfooter");
    if (footer) {
      footer.classList.add("d-none");
    }
    // Check if already logged in
    const user = localStorage.getItem('user');
    if (user) {
      this.$router.push('/admin');
    }
  },
  unmounted() {
    // Show footer again
    const footer = document.querySelector(".thisfooter");
    if (footer) {
      footer.classList.remove("d-none");
    }
  },
  methods: {
    handleLogin() {
      this.loading = true;
      this.errorMsg = '';
      const baseUrl = process.env.VUE_APP_DATA_URL || '/api/';
      
      fetch(baseUrl + 'login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: this.email,
          password: this.password
        })
      })
      .then(res => res.json())
      .then(res => {
        this.loading = false;
        if (res.success === 1) {
          localStorage.setItem('user', JSON.stringify(res.user));
          this.$router.push('/admin');
        } else {
          this.errorMsg = res.msg || 'Invalid credentials';
        }
      })
      .catch(err => {
        this.loading = false;
        this.errorMsg = 'Network error, please try again.';
        console.error(err);
      });
    }
  }
})
</script>

<style scoped>
.login-wrapper {
  background: linear-gradient(135deg, #0f2027, #203a43, #2c5364);
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.login-container {
  width: 100%;
  max-width: 450px;
}

.login-card {
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 16px;
  padding: 40px 30px;
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.37);
  color: #ffffff;
}

.auth-title {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 8px;
  letter-spacing: 0.5px;
}

.auth-subtitle {
  font-size: 14px;
  color: #b0bec5;
  margin-bottom: 30px;
}

.form-label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #eceff1;
}

.form-input {
  width: 100%;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  padding: 12px 16px;
  color: #ffffff;
  font-size: 16px;
  transition: all 0.3s ease;
}

.form-input::placeholder {
  color: #90a4ae;
}

.form-input:focus {
  outline: none;
  background: rgba(255, 255, 255, 0.15);
  border-color: #00e5ff;
  box-shadow: 0 0 8px rgba(0, 229, 255, 0.25);
}

.error-banner {
  background: rgba(239, 83, 80, 0.2);
  border: 1px solid #ef5350;
  border-radius: 8px;
  color: #ff8a80;
  padding: 10px 14px;
  font-size: 14px;
  text-align: center;
}

.btn-submit {
  width: 100%;
  background: linear-gradient(90deg, #00d2ff 0%, #0066ff 100%);
  border: none;
  border-radius: 8px;
  padding: 14px;
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 10px;
  box-shadow: 0 4px 15px rgba(0, 102, 255, 0.4);
}

.btn-submit:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 102, 255, 0.6);
}

.btn-submit:active:not(:disabled) {
  transform: translateY(0);
}

.btn-submit:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
